import { MdBedroomParent } from "react-icons/md";
export const LinksData = [
  {
    linkText: "Home",
    linkTo: "/",
  },
  {
    linkText: "About",
    linkTo: "/about",
  },
  {
    linkText: "Luxury rentals",
    linkTo: "/luxury-rentals",
  },
  {
    linkText: "Yachts",
    linkTo: "/yachts",
  },
  {
    linkText: "Private Jets",
    linkTo: "/private-jets",
  },
  {
    linkText: "Concierge",
    linkTo: "/concierge",
  },
  {
    linkText: "Security",
    linkTo: "/security",
  },
  {
    linkText: "Property Management",
    linkTo: "/property-management",
  },
  {
    linkText: "Partner with us",
    linkTo: "/partner-with-us",
  },
  {
    linkText: "Blog",
    linkTo: "/blog",
  },
  {
    linkText: "Testimonials",
    linkTo: "/testimonials",
  },
  {
    linkText: "Press",
    linkTo: "/press",
  },
  {
    linkText: "FAQ",
    linkTo: "/faq",
  },
  {
    linkText: "Contact",
    linkTo: "/contact",
  },
];

export const rental = [
  {
    id: 1,
    heading: "Miami Florida - Lorem Ipsum Dolore Sit Amet",
    bedroomLogo: <MdBedroomParent />,
    bedrooms: "6",
    guestLogo: <MdBedroomParent />,
    guests: "20",
    amount: "$1850",
    image: "/assets/Rental/Rental1.png",
  },
  {
    id: 2,

    heading: "Miami Florida - Lorem Ipsum Dolore Sit Amet",
    bedroomLogo: <MdBedroomParent />,
    bedrooms: "8",
    guestLogo: <MdBedroomParent />,
    guests: "12",
    amount: "$1850",
    image: "/assets/Rental/Rental3.png",
  },
  {
    id: 3,

    heading: "Miami Florida - Lorem Ipsum Dolore Sit Amet",
    bedroomLogo: <MdBedroomParent />,
    bedrooms: "9",
    guestLogo: <MdBedroomParent />,
    guests: "14",
    amount: "$1850",
    image: "/assets/Rental/Rental3.png",
  },
  {
    id: 4,

    heading: "Miami Florida - Lorem Ipsum Dolore Sit Amet",
    bedroomLogo: <MdBedroomParent />,
    bedrooms: "3",
    guestLogo: <MdBedroomParent />,
    guests: "12",
    amount: "$1850",
    image: "/assets/Rental/Rental4.png",
  },
  {
    id: 5,

    heading: "Miami Florida - Lorem Ipsum Dolore Sit Amet",
    bedroomLogo: <MdBedroomParent />,
    bedrooms: "12",
    guestLogo: <MdBedroomParent />,
    guests: "16",
    amount: "$1850",
    image: "/assets/Rental/Rental5.png",
  },
  {
    id: 6,

    heading: "Miami Florida - Lorem Ipsum Dolore Sit Amet",
    bedroomLogo: <MdBedroomParent />,
    bedrooms: "5",
    guestLogo: <MdBedroomParent />,
    guests: "13",
    amount: "$1850",
    image: "/assets/Rental/Rental6.png",
  },
];
